import { render, staticRenderFns } from "./property-situation.vue?vue&type=template&id=26f8075e&scoped=true"
import script from "./property-situation.vue?vue&type=script&lang=js"
export * from "./property-situation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f8075e",
  null
  
)

export default component.exports